import apiExcel from '@/api/excel'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  excelTariffsStart: '[excel] excel tariffs start',
  excelTariffsSuccess: '[excel] excel tariffs success',
  excelTariffsFailure: '[excel] excel tariffs failure',
}

export const actionTypes = {
  excelTariffs: '[excel] tariffs excel',
}

const mutations = {
  [mutationTypes.excelTariffsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.excelTariffsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.excelTariffsFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.excelTariffs](context, {year}) {
    context.commit(mutationTypes.excelTariffsStart)
    return new Promise((resolve) => {
      apiExcel
        .tariff(year)
        .then((response) => {
          context.commit(mutationTypes.excelTariffsSuccess)
          const file = new Blob([response.data], {
            type: response.headers['content-type'],
          })

          const link = URL.createObjectURL(file)
          resolve(link)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.excelTariffsFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
